{
  "version": 1,
  "asset_id": "60d0482c-1e7b-489e-9479-0f7ef2c9df29",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/60d0482c-1e7b-489e-9479-0f7ef2c9df29/sleeve-gastrectomy-es-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/60d0482c-1e7b-489e-9479-0f7ef2c9df29/sleeve-gastrectomy-es-v2-800.jpg",
  "original_filename": "sleeve-gastrectomy-es-v2-800.jpg",
  "size": 61403,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:39Z"
}
